/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import createReactClass from 'create-react-class';
import { combineReducers } from 'redux';
import {setCacheItem, getReducers, getCacheItem} from '../helpers/cacheManager';
import store from '../helpers/store';

import each from 'lodash/each';
import extend from 'lodash/extend';

import fetch from '../helpers/fetch';
import mutate from '../helpers/mutate';
import setStatus from '../helpers/setStatus';
import set from '../helpers/set';
import setQuery from '../helpers/setQuery';
import setDefaults from '../helpers/setDefaults';
import getReducer from '../helpers/getReducer';

const WithContainer = (Component, containerProps) => createReactClass({

  getInitialState() {
    let refreshedReducers = 0;

    each(containerProps.cache, (cache, cacheKey) => {
      const connectedCache = getCacheItem(cacheKey);
      if (!connectedCache && !cache.isListener) {
        refreshedReducers += 1;

        setDefaults({ cache });

        let resolvedQuery = cache.query;

        if (cache.getQuery) {
          resolvedQuery = cache.getQuery({ props: this.props }) || {};
        }

        setCacheItem(cacheKey, {
          cacheKey,
          ...cache,
          query: resolvedQuery,
          isStale: true,
          isReady: false,
          reducer: (getReducer)({ cacheKey, initialData: cache.initialData }),
        });
      }

    });

    if (refreshedReducers > 0) {
      store.replaceReducer(combineReducers(getReducers()));
    }

    this.unsubscribe = store.subscribe(this.onStoreUpdate);

    return {
      isReady: false,
    };

  },

  componentDidMount() {
    this.isMounted = true;
    this.setState({ isReady: true });
  },

  componentWillUnmount() {
    this.isMounted = false;
    this.unsubscribe();
  },

  onStoreUpdate() {
    if (!this.isMounted) return;
    const state = store.getState();
    const { lastAction } = state;
    if (lastAction && lastAction.type && containerProps.cache) {
      const lastActionSplit = lastAction.type.split(':');
      if (lastActionSplit && lastActionSplit[0]) {
        if (containerProps.cache[lastActionSplit[0]]) {
          this.forceUpdate();
        }
      }
    }
  },

  render() {

    if (!this.state.isReady) return null;

    const returnedState = {};

    let joinedProps = {};

    const state = store.getState();

    each(containerProps.cache, (cache, cacheKey) => {
      const connectedCache = getCacheItem(cacheKey);

      if (!connectedCache) {
        returnedState[cacheKey] = {
          data: null,
          status: 'unresolved',
        };
        return;
      }

      const { isStale, query } = connectedCache;

      returnedState[cacheKey] = {
        set: (update, options = {}) => set({ update, options, cacheKey }),
        setStatus: status => setStatus({ status, cacheKey }),
        setQuery: (update, options = {}) => setQuery({ update, options, cacheKey }),
        fetch: (options = {}) => fetch({ props: joinedProps, cacheKey, options }),
        mutate: (update, options = {}) => mutate({
          update, props: joinedProps, cacheKey, options,
        }),
        query,
        ...state[cacheKey],
        isStale,
      };

    });

    joinedProps = extend(joinedProps, this.props, returnedState);

    const WrappedComponent = Component;

    return <WrappedComponent {...this.state} {...returnedState} {...this.props} />;

  },
});

export default WithContainer;
